/** @format */
import React, { useState, useEffect, useRef } from 'react';
import { Grid } from '@mui/material';
import { InputV2, InfoBox, CommonTooltip, ButtonLoading, Icons } from 'components';
import InquiryAgentDg from './InquiryAgentDg';
import { useFormContext } from 'react-hook-form';
import { checkContactDelegation } from '../../../DigitalAccount/ReceivedDelegationList/ReceivedDelegation/components/TransferDelegation/services/TransferDelegationServices';
import createToast from 'components/Toast/Toast';
import { validator } from 'myValidation';
import { useStyles } from './style';

const AgentInfo = ({ isLegal, businessInfo }) => {
  const classes = useStyles();

  const methods = useFormContext();
  const [fullNameAgent, setfullNameAgent] = useState('');

  const [isLoadingAgentDg, setIsLoadingAgentDg] = useState(false);
  const [isOpenAgentDg, setIsOpenAgentDg] = useState(false);
  const [enteredCaptchaAgent, setEnteredCaptchaAgent] = useState('');
  const [captchaIdAgentDg, setCaptchaIdAgentDg] = useState(null);
  const [agentValues, setAgentValues] = useState({
    agentCellphoneNumber: '',
    agentNationalCode: '',
  });
  const captachaAgentRef = useRef();
  useEffect(() => {
    setAgentValues({
      agentCellphoneNumber: businessInfo?.agent?.cellphoneNumber || '',
      agentNationalCode: businessInfo?.agent?.nationalCode || '',
    });
    setfullNameAgent(
      businessInfo?.agent?.firstName
        ? businessInfo?.agent?.firstName + ' ' + businessInfo?.agent?.lastName
        : '',
    );
  }, []);
  const getBranchAgent = async () => {
    try {
      const contactInfo = agentValues.agentCellphoneNumber;
      const nationalCode = agentValues.agentNationalCode;

      const body = {
        captchaAnswer: enteredCaptchaAgent,
        captchaId: captchaIdAgentDg,
      };
      if (nationalCode?.length > 0) {
        if (!validator.isNumeric(nationalCode ?? '')) {
          createToast('خطا', ' کد ملی نماینده باید عدد باشد.', 'danger');
          captachaAgentRef?.current?.onMakeCaptcha();
          return;
        } else if (nationalCode?.length !== 10) {
          createToast('خطا', ' کد ملی نماینده باید 10 رقم باشد.', 'danger');
          captachaAgentRef?.current?.onMakeCaptcha();

          return;
        }
      }

      if (validator.isMobilePhone(contactInfo ?? '')) {
        body.phoneNumber = contactInfo;
      } else {
        createToast('خطا', ' شماره همراه نماینده معتبر نمی‌باشد.!', 'danger');
        captachaAgentRef?.current?.onMakeCaptcha();
        return;
      }
      setIsLoadingAgentDg(true);
      const data = await checkContactDelegation(body);

      if (data?.result?.given_name && data?.result?.family_name) {
        methods.setValue('agent.firstName', `${data?.result?.given_name}`);
        methods.setValue('agent.lastName', `${data?.result?.family_name}`);
        methods.setValue('agent.nationalCode', agentValues.agentNationalCode);
        methods.setValue('agent.cellphoneNumber', agentValues.agentCellphoneNumber);
        setTimeout(() => {
          setfullNameAgent(data?.result?.given_name + ' ' + data?.result?.family_name);
        }, 100);
      }
      if (!contactInfo) {
      }
      setIsLoadingAgentDg(false);
      setIsOpenAgentDg(false);
    } catch (error) {
      setIsLoadingAgentDg(false);
      captachaAgentRef?.current?.onMakeCaptcha();
    }
  };

  return (
    <>
      <Grid container item xs={12}>
        <InfoBox
          type="disable"
          content="نماینده کسب‌وکار فردی است که به نمایندگی از صاحبان امضای شرکت اجازه دسترسی به سایت و پنل پادیوم را دارد. فرآیند تایید دسترسی نمایندگی، توسط کارشناسان پادیوم انجام می‌شود."
        />
        <Grid container item xs={12} spacing={3}>
          <Grid item lg={6} md={6} xs={12} style={{ margin: '16px 0' }}>
            {fullNameAgent ? (
              <Grid className={classes.inquiryBox} item md={12} xs={12}>
                <Grid item md={6} xs={12}>
                  <InputV2
                    fullWidth
                    errors={methods.formState.errors}
                    label="نام و نام خانوادگی نماینده"
                    name="agentFullName"
                    control={methods.control}
                    register={methods.register}
                    style={{ backgroundColor: 'rgb(239 239 239)' }}
                    forceValue={fullNameAgent}
                    disabled
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  <ButtonLoading
                    type="button"
                    color="primary"
                    variant="outlined"
                    className={classes.btnChange}
                    onClick={() => {
                      setIsOpenAgentDg(true);
                    }}
                    name={
                      <>
                        <span style={{ marginLeft: '5px', display: 'flex' }} >
                          <Icons icon='editPen' color="#303D8F" size="18" />
                        </span>
                        تغییر نماینده
                      </>
                    }
                  />
                </Grid>
              </Grid>
            ) : (
              <Grid item md={6} xs={12} style={{ display: 'flex' }}>
                <ButtonLoading
                  type="button"
                  color="primary"
                  variant="outlined"
                  style={{ margin: '10px 20px 10px 0' }}
                  onClick={() => {
                    setIsOpenAgentDg(true);
                  }}
                  name={
                    <>
                      <span style={{ marginLeft: '5px', display: 'flex' }} >
                        <Icons icon='plusCircle' color="#303D8F" size="18" />
                      </span>
                      افزودن نماینده
                    </>
                  }
                />

                <Grid
                  style={{
                    marginRight: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    direction: 'ltr',
                    opacity: '0.8',
                  }}
                >
                  <CommonTooltip
                    placement="left"
                    title="اطلاع‌رسانی‌های ضروری به شماره موبایل نماینده ارسال می‌شود. از این‌رو توجه داشته باشید که این شماره در دسترس باشد. سطح مالی نماینده می بایست حداقل 3 باشد."
                  >
                    <span className={classes.infoIcon}>
                      <Icons icon='Info' color='#667585' hover='#667585' size='20' />
                    </span>
                  </CommonTooltip>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>

      <Grid item lg={3} md={6} xs={12} style={{ display: 'none' }}>
        <InputV2
          name="agent.firstName"
          style={{ display: 'none' }}
          control={methods.control}
          register={methods.register}
          hide
        />
        <InputV2
          name="agent.lastName"
          style={{ display: 'none' }}
          control={methods.control}
          register={methods.register}
          hide
        />
        <InputV2
          name="agent.cellphoneNumber"
          style={{ display: 'none' }}
          control={methods.control}
          register={methods.register}
          hide
        />
        <InputV2
          name="agent.nationalCode"
          style={{ display: 'none' }}
          control={methods.control}
          register={methods.register}
          hide
        />
      </Grid>
      <InquiryAgentDg
        isLoadingAgentDg={isLoadingAgentDg}
        setIsLoadingAgentDg={setIsLoadingAgentDg}
        isOpenAgentDg={isOpenAgentDg}
        setIsOpenAgentDg={setIsOpenAgentDg}
        enteredCaptchaAgent={enteredCaptchaAgent}
        setEnteredCaptchaAgent={setEnteredCaptchaAgent}
        captchaIdAgentDg={captchaIdAgentDg}
        setCaptchaIdAgentDg={setCaptchaIdAgentDg}
        captachaAgetRef={captachaAgentRef}
        methods={methods}
        getBranchAgent={getBranchAgent}
        setAgentValues={setAgentValues}
        agentValues={agentValues}
        agentFullName={fullNameAgent}
      />
    </>
  );
};

export default AgentInfo;
